var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-order-deeplink-component"},[_vm._v("\n  Redirecting...\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }